<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div class="workspace">
    <div class="section-heading">
      <h2>Account Settings</h2>
    </div>
    <div class="user-edit-cont">
      <div class="user-edit-row">
        <h4>First Name*</h4>
        <input type="text" class="tr-input" v-model="name" name="Name" v-validate="'required'" >
        <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
      </div>
      <div class="user-edit-row">
        <h4>Last Name</h4>
        <input type="text" class="tr-input" v-model="last_name" name="Last Name" v-validate="'required'" >
        <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
      </div>
      <div class="user-edit-row">
        <h4>Email*</h4>
        <input type="email" class="tr-input" v-model="email" name="Email" v-validate="'required'" >
        <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
      </div>
      <div class="user-edit-row">
        <h4 v-if="!changePass">Password*</h4>
        <div id="password-change-box" class="password-change-box active" v-if="changePass">
          <div class="user-edit-row">
            <h4>Current Password</h4>
            <input type="password" class="tr-input">
          </div>
          <div class="user-edit-row">
            <h4>New Password</h4>
            <input type="password" class="tr-input">
          </div>
          <div class="user-edit-row">
            <h4>Confirm New Password</h4>
            <input type="password" class="tr-input">
          </div>
        </div>
        <div @click="changePass = !changePass" v-if="!changePass" class="tr-button blue-button margin-top margin-bottom">{{changePass ? 'Cancel Change' : 'Change Password' }}</div>

      </div>

      <div class="tr-button green-button" @click="saveEditUser">SAVE CHANGES</div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'

export default {
  name: 'Users',
  data () {
    return {
      changePass: false,
      searchString: '',
      searchedUsers: [],
      filterData: 0,
      selectedUserId: 0,
      addUser: false,
      editUser: false,
      user_group: 2,
      user_group_options: [{label: 'Restaurant Owner', value: 2}, {label: 'Editor', value: 3}, {label: 'Admin', value: 4}],
      name: '',
      last_name: '',
      email: '',
      format: 'yyyy-MM-dd',
      password: '',
      isTermsConditionAccepted: true
    }
  },
  watch: {
    filterData () {
    },
    user_group () {
    },
    searchString () {
      this.searchUsers()
    },
    editUser () {
      if (!this.editUser) {
        this.clearUserData()
      }
    },
    addUser () {
      if (this.addUser && this.editUser) {
        this.editUser = false
      }
      if (!this.addUser) {
        this.clearUserData()
      }
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.api.currentUser
    }
  },
  components: {
    vSelect
  },
  methods: {
    openAlert (text) {
      this.$vs.dialog({
        type:'alert',
        clickNotClose: true,
        color: 'success',
        title: 'Confirm',
        acceptText: 'Ok',
        text
      })
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        clickNotClose: true,
        text: 'Are you sure you want to delete this user?',
        accept,
        cancel
      })
    },

    deleteUser () {

      this.openConfirm(() => {
        const obj = {
          user_id: this.selectedUserId
        }
        this.$store.dispatch('api/removeUser', obj).then(() => {
          this.$vs.notify({
            title: 'Delete',
            text: 'Item deleted succesfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.editUser = false
          location.reload()
        }).catch(err => { console.error(err) })
      }, () => {

      })
    },
    saveEditUser () {
      this.$validator.validateAll().then(result => {
        if (result) {

          this.$vs.loading()
          const payload = {
            user_id: this.selectedUserId,
            name: this.name,
            email: this.email,
            last_name: this.last_name,
            user_group: this.user_group
          }

          if (this.changePass) {

            const passPayload = {
              oldPassword: this.password,
              newPassword: this.newpassword,
              repeatNewPassword: this.newpassword2
            }

            this.$store.dispatch('api/changePassword', passPayload)
              .then(result => {
                if (result) {
                  this.saveProfileData(payload)
                }
              })
              .catch(error => {
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Error',
                  text: error.message,
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                })
              })
          } else {
            this.saveProfileData(payload)
          }
        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'Please enter valid details',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }
      })

    },
    saveProfileData (payload) {

      this.$store.dispatch('api/updateUserSelf', payload).then(() => {
        this.openAlert('Information saved successfully')
        this.getUsers()
        this.editUser = false
        this.$vs.loading.close()
      }).catch(err => {
        console.error(err.message)
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })

    },
    clearUserData () {
      this.name = ''
      this.last_name = ''
      this.email = ''
      this.user_group = 2
    },
    handleEditUser (user) {
      const {id, name, last_name, email, user_group} = user
      this.name = name
      this.last_name = last_name
      this.email = email
      this.user_group = user_group
      this.selectedUserId = id
      this.editUser = true
    }
  },
  mounted () {
    this.handleEditUser(this.activeUserInfo)
  }
}
</script>

<style lang="scss">
.align-right {
  text-align: right;
}
</style>
